import type { CommentItem } from '@wlb/shared/types/comments';

const backendCommentId = (comment: CommentItem): string =>
  comment.postCommentId != null ? String(comment.postCommentId) : comment.id;

/** Resolves the API ID of the exact comment or reply selected by the user. */
export const resolveReplyParentId = (
  comments: CommentItem[],
  target: CommentItem | null,
): string | undefined => {
  if (!target) return undefined;
  if (target.postCommentId != null) return String(target.postCommentId);

  for (const root of comments) {
    if (root.id === target.id) return backendCommentId(root);
    if ((root.replies ?? []).some(reply => reply.id === target.id)) {
      return backendCommentId(root);
    }
  }

  return target.id.startsWith('comment-') ? undefined : target.id;
};
